import { render, staticRenderFns } from "./Programa-view-planes.vue?vue&type=template&id=3b1022da&scoped=true"
import script from "./Programa-view-planes.vue?vue&type=script&lang=js"
export * from "./Programa-view-planes.vue?vue&type=script&lang=js"
import style0 from "./Programa-view-planes.vue?vue&type=style&index=0&id=3b1022da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1022da",
  null
  
)

export default component.exports